import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
//import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom"
import './index.css'
import { BASENAME } from './services/utils'

import reportWebVitals from "./reportWebVitals"

//const hasDevelopment = process.env.NODE_ENV === 'development'
// const devBaseName    = process.env.REACT_APP_BASENAME_DEV
// const prodBaseName   = process.env.REACT_APP_BASENAME 
// const buildPath      = process.env.PUBLIC_URL

// const basename = buildPath === devBaseName ? devBaseName : prodBaseName 
//const basename = devBaseName

// process.env.REACT_APP_BASE_BASENAME

// import TagManager from 'react-gtm-module'

// const tagManagerArgs = {
//     gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER
//     //preview: 'env'
// }

// TagManager.initialize(tagManagerArgs)
const container = document.getElementById('root')
const root = createRoot(container)
root.render(
    <BrowserRouter basename={BASENAME} >
        <App/>
    </BrowserRouter>
)

reportWebVitals()
